import { atom } from "jotai";

/**
 * Indicates whether the payment method modals should be open or not
 * Very simple toggle boolean.
 */
export const isPaymentMethodEntryModalOpenAtom = atom(false);

export const isNotificationsNudgeModalOpenAtom = atom(false);
export const isPaymentMethodEntryUpdatingAtom = atom(false);

export const isGiftCardModalOpenAtom = atom(false);
